export default {
    components: {
    },
    props: ['value', 'name'],
    name: 'ReadonlyText',
    data() {
        return {
        };
    },
};